import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpQueryPatternExisted implements ICommand
{

	public Existed : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Existed = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.Existed);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpQueryPatternExisted();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Existed(B)='+this.Existed+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50092;
	}

	public getCmdName() : string
	{
		return 'SpQueryPatternExisted';
	}

}
